module.exports = __webpack_public_path__ + "img/ug522.e3578a06.png";